import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, } from 'react';
import styled, { useTheme } from 'styled-components';
import Flex from '../../atoms/Flex';
import Button from '../../atoms/Button';
import PaperPlane from '../../atoms/icons/PaperPlane';
import FileUploader from '../../atoms/FileUploader';
const StyledPaperPlane = styled(PaperPlane) `
    fill: white;
`;
const StyledButton = styled(Button) `
    height: 100%;
    margin-top: auto;
`;
const Buttons = forwardRef(({ loading, data, setData }, fileUploaderRef) => {
    const theme = useTheme();
    return (_jsxs(Flex, { justifyContent: "space-between", children: [_jsx(FileUploader, { ref: fileUploaderRef, data: data, setData: setData, isDisabled: loading }), _jsx(StyledButton, { type: "submit", isLoading: loading, tertiary: true, icon: _jsx(StyledPaperPlane, {}), 
                //@ts-ignore
                loaderColor: theme.primary.dark, children: "Bericht verzenden" })] }));
});
export default Buttons;
